export default "__VITE_ASSET__3cc29c43__"